"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var themes = {
    simple: {
        label: undefined,
        legend: false,
        xAxis: {
            label: null,
            grid: null,
        },
        yAxis: {
            label: null,
            grid: null,
        },
    },
    "default-with-dotted-grid": {
        // isGroup: true,
        legend: {
            layout: "horizontal",
            position: "bottom",
        },
        animation: {
            enter: {
                duration: 1000,
            },
        },
        yAxis: {
            grid: {
                line: {
                    style: {
                        stroke: "gray",
                        lineDash: [4, 4],
                        strokeOpacity: 0.7,
                    },
                },
            },
        },
    },
};
exports.default = themes;
